const logoDataUrl = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKoAAAA2CAYAAABX0gK6AAALnHpUWHRSYXcgcHJvZmlsZSB0eXBl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`.replace(/\s+/g, '');

export default logoDataUrl;
